import React from "react"
import Image from "../../ui/image/image"
import cx from "classnames"

//Styles
import "./review-block.scss"
import useMediaQuery from "../../../hooks/useMediaQuery"
import SvgIcon from "../../../hooks/svg"

const ReviewBlock = props => {
  const componentProps = props.blok ? props.blok : props.prop
  const isTabletOrMobile = useMediaQuery(1024)

  const colorMode = isTabletOrMobile
    ? componentProps.color_mode_mobile
    : componentProps.color_mode

  return (
    <>
      {componentProps.link.url !== "" ? (
        <div
          className={cx(
            "review-block",
            {
              "review-block--light": colorMode === "light",
            },
            {
              "review-block--dark": colorMode === "dark",
            },
            {
              "padding-top": componentProps.paddingTop,
            },
            {
              "padding-bottom": componentProps.paddingBottom,
            }
          )}
        >
          <a href={componentProps.link.url}>
            <div className="grid-container">
              <div className="review-block__content">
                <div className="review-block__content--rating">
                  <span>{componentProps.rating}mjau</span>
                </div>
                <div className="review-block__content--image">
                  <SvgIcon name="starsblack" />
                </div>
                <div className="review-block__content--text">
                  <span>{componentProps.text}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
      ) : (
        <div
          className={cx(
            "review-block",
            {
              "review-block--light": colorMode === "light",
            },
            {
              "review-block--dark": colorMode === "dark",
            }
          )}
        >
          <div className="grid-container">
            <div className="review-block__content">
              <div className="review-block__content--rating">
                <span>{componentProps.rating}</span>
              </div>
              <div className="review-block__content--image">
              <SvgIcon name="stars" />

              </div>
              <div className="review-block__content--text">
                <span>{componentProps.text}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ReviewBlock
